import { render, staticRenderFns } from "./DetalharUsoSetorDialog.vue?vue&type=template&id=4d13104a&scoped=true"
import script from "./DetalharUsoSetorDialog.vue?vue&type=script&lang=js"
export * from "./DetalharUsoSetorDialog.vue?vue&type=script&lang=js"
import style0 from "./DetalharUsoSetorDialog.vue?vue&type=style&index=0&id=4d13104a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d13104a",
  null
  
)

export default component.exports